// src/layouts/UserLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import { ScorerHeader } from '../components/index';

const ScorerLayout = () => {
  return (
    <div className="layout_bg_participant" style={{height:"100vh"}}>
      <ScorerHeader />
      <Outlet />

    </div>
  );
};

export default ScorerLayout;


